export enum MaterialVariant {
  'Outline' = 'material-outline',
  'Filled' = 'material-filled',
  'Rounded' = 'material-rounded',
  'Sharp' = 'material-sharp',
  'Two Tone' = 'material-two-tone',
}

export function isMaterialVariant(value: string): value is MaterialVariant {
  return value === MaterialVariant.Filled || value === MaterialVariant.Outline || value === MaterialVariant.Rounded || value === MaterialVariant.Sharp || value === MaterialVariant['Two Tone'];
}

export const MaterialType = 'material';
